/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MisconfigurationViolationsByCloudAccountWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("MisconfigurationViolationsByCloudAccountWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return MisconfigurationViolationsByCloudAccountWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<MisconfigurationViolationsByCloudAccountWidgetConfiguration>): MisconfigurationViolationsByCloudAccountWidgetConfiguration {
        let obj = Object.assign(new MisconfigurationViolationsByCloudAccountWidgetConfiguration(), model);
        MisconfigurationViolationsByCloudAccountWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MisconfigurationViolationsByCloudAccountWidgetConfiguration>): MisconfigurationViolationsByCloudAccountWidgetConfiguration {
        if (!model) return null;
        return MisconfigurationViolationsByCloudAccountWidgetConfiguration.newInstance(<MisconfigurationViolationsByCloudAccountWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MisconfigurationViolationsByCloudAccountWidgetConfiguration) {
        if (!obj) return;

        models.MisconfigurationViolationsByCloudAccountWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MisconfigurationViolationsByCloudAccountWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, MisconfigurationViolationsByCloudAccountWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
